export const FREQUENCY_TYPES = {
  ONE_TIME: 'ONE_TIME',
  RECURRING: 'RECURRING',
  // ONBOARDING: 'ONBOARDING',
} as const;

export const FREQUENCY_LABELS = {
  ONE_TIME: 'One Time',
  RECURRING: 'Recurring',
  ONBOARDING: 'Onboarding',
} as const;

export type OneTimeState = {
  type: typeof FREQUENCY_TYPES.ONE_TIME;
  date: Date | null;
  openFor: number;
};

export type RecurringState = {
  type: typeof FREQUENCY_TYPES.RECURRING;
  date: Date | null;
  recurrenceRule: string;
  openFor: number;
};

// export type OnboardingState = {
//   type: typeof FREQUENCY_TYPES.ONBOARDING;
//   daysAfterJoining: number;
//   openFor: number;
// };

export type EngagementFrequencyState = OneTimeState | RecurringState /* | OnboardingState */;

export const EMPLOYEE_PRIVACY_VALUES = {
  ANONYMOUS: 'ANONYMOUS',
  SEMI_ANONYMOUS: 'SEMI_ANONYMOUS',
  NON_ANONYMOUS: 'NON_ANONYMOUS',
} as const;

export const EMPLOYEE_PRIVACY_LABELS = {
  ANONYMOUS: 'Anonymous',
  SEMI_ANONYMOUS: 'Semi-Anonymous',
  NON_ANONYMOUS: 'Non-Anonymous',
} as const;

export type EmployeePrivacy = keyof typeof EMPLOYEE_PRIVACY_VALUES;

export type SurveyReminderOption = {
  label: string;
  value: string;
};

export type SurveyReminders = SurveyReminderOption[];

export type SurveyFormResponse = {
  id: number;
  active: boolean;
  name: string;
  reviewCycle: string | null;
  currentStage: string;
  currentStageName: string;
  currentStageDescription: string;
  lastEnabledSection: string;
  formType: string;
  surveyDrivers: null;
  publishedBy: null;
  publishedOn: null;
  formSubType: null;
  cohortId: null;
  displayOrder: null;
  selectedFilters: {
    LOCATION: (string | null)[] | null;
    COMPANY_ID: { companyName: string; id: number } | null;
  };
  totalEmployeeCount: number | null;
  revieweeSelectionType: string | null;
};

export type SurveySettings = {
  id: number;
  created: string;
  feedbackFormId: number;
  startDate: string | null;
  endDate: string | null;
  isAnonymous: boolean | null;
  isPublic: boolean | null;
  frequency: null;
  participantsCohortId: number;
  activeDays: null;
  startDayDiff: null;
  visibilityType: (typeof EMPLOYEE_PRIVACY_VALUES)[keyof typeof EMPLOYEE_PRIVACY_VALUES];
};

export type SurveyTemplate = {
  id: number;
  name: string;
  createdBy: string;
  questionCount: number;
  isSample: boolean;
};

type NoTemplateSelectedResponse = {
  timestamp: string;
  status: string;
  error: string;
  message: string;
  entityObject: null;
  statusMessage: null;
};

type TemplateSelectedResponse = {
  message: string;
  entity: {
    id: number;
    created: string;
    name: string;
    formType: string;
    createdByEmployeeId: null;
    isArchived: boolean;
    questionCount: number;
    templateSetting: null;
    createdByEmployee: null;
    isSample: boolean;
    ongoingReviewCycleCount: number;
    createdByEmployeeMiniProfile: null;
  };
};

export type SelectedSurveyTemplateResponse = NoTemplateSelectedResponse | TemplateSelectedResponse;

export type SurveyRemindersResponse = {
  reviewStage: string;
  daysBeforeDeadline: number;
  audience: string;
}[];
